import CryptoJS from "crypto-js";
export default {
  Encrypt(word) {
    var key = CryptoJS.enc.Utf8.parse("zsrj00523de6r890");
    var iv = CryptoJS.enc.Utf8.parse("zsrf001d34567890");
    var srcs = CryptoJS.enc.Utf8.parse(word);
    var encrypted = CryptoJS.AES.encrypt(srcs, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
      blockSize: 128,
      sigBytes: 16
    });
    encrypted.blockSize = 128;
    return encrypted.toString();
  },
  //解密
  Decrypt(word, keyStr) {
    keyStr = keyStr ? keyStr : "zsrj00523de6r890";
    var key = CryptoJS.enc.Utf8.parse(keyStr); //Latin1 w8m31+Yy/Nw6thPsMpO5fg==
    var decrypt = CryptoJS.AES.decrypt(word, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
  }
};
